import React from 'react';
import { Modal, message } from 'antd';

const ConfirmModal = ({ 
  isVisible, 
  onClose, 
  selectedProducts, 
  onConfirm 
}) => {
  return (
    <Modal
      title="Confirmare Produse Noi"
      open={isVisible}
      onOk={() => {
        onConfirm();
        message.success('Produse confirmate cu succes!');
      }}
      onCancel={onClose}
    >
      <p>Doriți să confirmați următoarele produse?</p>
      <ul>
        {selectedProducts.map(product => (
          <li key={product.id}>
            {product.product_name} - {product.quantity} buc. - {product.sale_price} MDL
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default ConfirmModal; 